import { useEffect } from 'react';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';

import { dataControlStore } from '@stores/dataControlStore';
import { organizationsStore } from '@stores/dictionaryStores/organizationsStore';
import type { PagesParamInterface } from '@stores/dataControlStore';

export const usePassingControlStorage = (): void => {
  const { addPage, setFilters, addBreadcrumbs } = dataControlStore;
  const { organizations } = organizationsStore;

  useEffect(() => {
    (async () => {
      const storage = localStorage.getItem('passingControlData');
      const parseStorage = storage ? JSON.parse(storage) : null;

      if (parseStorage) {
        const name = organizations.find((org) => org.code === parseStorage.organization)?.name ?? '';

        setFilters({ organization: parseStorage.organization }, 'generalReport');

        const breadcrumbs = [name, parseStorage.reportPackageCodeCm];

        const pages: PagesParamInterface[] = [
          { controlType: 'generalReport' },
          {
            controlType: 'packageLevel',
            reportPackageCodeCm: parseStorage.reportPackageCodeCm,
            filters: [
              [
                {
                  name: 'report_package_code_cm',
                  type: FILTER.EQ,
                  values: [parseStorage.reportPackageCodeCm],
                  filterIsInverted: false,
                },
              ],
            ],
          },
        ];

        if (parseStorage.controlLevel) {
          breadcrumbs.push(parseStorage.ctrlVersCode);

          pages.push({
            controlType: 'controlLevel',
            reportPackageCodeCm: parseStorage.reportPackageCodeCm,
            filters: [
              [
                {
                  name: 'report_package_code_cm',
                  type: FILTER.EQ,
                  values: [parseStorage.reportPackageCodeCm],
                  filterIsInverted: false,
                },
                {
                  name: 'ctrl_vers',
                  type: FILTER.EQ,
                  values: [parseStorage.ctrlVersCode],
                  filterIsInverted: false,
                },
              ],
            ],
          });
        }

        addBreadcrumbs(breadcrumbs, true);
        addPage(pages, true);

        localStorage.removeItem('passingControlData');
      }
    })();
  }, [addBreadcrumbs, addPage, organizations, setFilters]);
};
